import {createAsyncThunk} from '@reduxjs/toolkit';
import {ThunkConfig} from "../../../config/StateSchema";
import {IRequestSpecialistsFind, ISpecialistFindCollection} from "../../types/specialistFindTypes";
import {BaseResponse} from "../../../../api/api";
import {snackbarAction} from "../../../errors/SnackbarSlice";

export interface IResponseUpdateProfile {
    collection: ISpecialistFindCollection[]
}

export interface ISpecialistsFindResult {
    collection: ISpecialistFindCollection[]
    isFallback: boolean
}

export const fetchSpecialistsFind = createAsyncThunk<ISpecialistsFindResult,
    IRequestSpecialistsFind,
    ThunkConfig<string>>(
        'specialistsFind/fetchSpecialistsFind',
        async (data, thunkAPI) => {
            const {extra, rejectWithValue, dispatch} = thunkAPI;
            try {
                const response = await extra.api.get<BaseResponse<IResponseUpdateProfile>>('profile/collection-spec', {
                    params: data
                })
                const isFallback = response.data.codeKey === 'SPEC_FALLBACK_RESULTS'
                if (!response.data.success && !isFallback) {
                    return rejectWithValue('error')
                }
                return {
                    collection: response.data.response.collection,
                    isFallback,
                }
            } catch (err) {
                dispatch(snackbarAction.addError('INTERNAL_ERROR'))
                return rejectWithValue('error');
            }
        },
    );
